module.exports = __webpack_public_path__ + "static/media/Central African Republic.2dd0f227.png";